import React, { useEffect, useState, useContext } from "react";
import { PageValue } from "../contexts/page";
import Dynamic from "./dynamic";

export default function SetState({ value, onChange, params, sources }) {
  const [_value, setValue] = useState({ stateVariable: "" });
  const { stateVariables } = useContext(PageValue);
  const [stateVariable, setStateVariable] = useState(null);

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
    }
  }, [value]);

  useEffect(() => {
    const sv = stateVariables.find((x) => x.value === _value.stateVariable);
    setStateVariable(sv);
  }, [_value.stateVariable]);

  const handleSelect = (e) => {
    const value = { ..._value };
    value.stateVariable = e.target.value;
    setValue(value);
  };

  const handleChange = (v) => {
    const value = { ..._value };
    value.value = v;
    onChange(value);
  };
  return (
    <div>
      <select
        className={"dropdown"}
        onChange={handleSelect}
        value={_value.stateVariable}
      >
        <option value={""} disabled>
          select
        </option>
        ;
        {stateVariables.map((sv) => {
          return <option value={sv.value}>{sv.displayName}</option>;
        })}
      </select>
      {stateVariable && (
        <>
          <div>Value</div>
          <Dynamic
            value={_value.value}
            onChange={handleChange}
            params={{ type: stateVariable.type, list: stateVariable.list }}
            sources={sources}
          />
        </>
      )}
    </div>
  );
}
